// @flow

import * as React from 'react';
import styles from './MastheadH1.less';

type Props = {|
  /**
   * masthead h1 text
   */
  mastheadH1Text: string,
|};

const MastheadH1 = (props: Props) => (
  <h1 className={`header ${styles.header}`}> {props.mastheadH1Text} </h1>
);

export default MastheadH1;
